import { render, staticRenderFns } from "./ModelLib.vue?vue&type=template&id=4f479d9e&scoped=true&"
import script from "./ModelLib.vue?vue&type=script&lang=ts&"
export * from "./ModelLib.vue?vue&type=script&lang=ts&"
import style0 from "./ModelLib.vue?vue&type=style&index=0&id=4f479d9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_lodash@4.17.15_vue-template-compiler@2.6.11_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f479d9e",
  null
  
)

export default component.exports